<template>
  <div>
    <b-card>
      <b-row>
        <div class="col-lg-5">
          <label class="w-100 border-bottom pb-2 label-header mb-3">Wallet Information</label>
          <div class="d-flex flex-wrap">
            <div class="d-flex mb-3 col-lg-6">
              <i class="mdi mdi-wallet me-2" style="margin-top: 6px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Bills Payment Wallet</p>
                <label class="mb-1">₱{{ businessDetails.billsBalance == 0 ? '0.00' : businessDetails.billsBalance.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-globe me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Wallet Address</p>
                <label class="mb-1">{{ businessDetails.cogUserSub }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-user-circle me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Store Owner</p>
                <label class="mb-1">{{ businessDetails.subscriberName }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-store-alt me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Business Name</p>
                <label class="mb-1">{{ businessDetails.businessName }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <label class="w-100 border-bottom pb-2 label-header mb-3">Financial Overview</label>
          <div class="d-flex flex-wrap">
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Incoming</p>
                <label class="mb-1">₱{{ billsMonthlyIncoming == null ? '0.00' : billsMonthlyIncoming.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Outgoing</p>
                <label class="mb-1">₱{{ billsMonthlyOutgoing == null ? '0.00' : billsMonthlyOutgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Daily Incoming</p>
                <label class="mb-1">₱{{ billsDailyIncoming == null ? '0.00' : billsDailyIncoming.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
                <p class="mb-1 fs-13px">as of {{ new Date() | formatDate }}</p>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Daily Outgoing</p>
                <label class="mb-1">₱{{ billsDailyOutgoing == null ? '0.00' : billsDailyOutgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
                <p class="mb-1 fs-13px">as of {{ new Date() | formatDate }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </b-card>

    <!-- Table Card-->
    <b-card>
      <div class="d-flex align-items-center mb-4">
        <h5 class="mb-0">{{ billsSellTxnTotal }} Record(s)</h5>
        <button class="btn btn-secondary ms-auto" @click="getBillsTransactions()">
          <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp; Refresh
        </button>
      </div>

      <div class="d-flex flex-wrap mb-4">
        <div class="ta-right me-3">
          <b-form-group description="Search Keyword">
            <div class="d-flex">
              <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width: fit-content"
                    id="input-3" v-model="search.field" :options="searchFields"></b-form-select>
              <b-form-input class="rounded-0 rounded-end" v-model="search.keyword" @keyup.enter="getBillsTransactions()"></b-form-input>
            </div>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Status">
            <b-form-select class="form-select rounded shadow-none status-form-select"
              v-model="search.status"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Transaction Date">
            <flat-pickr
              v-model="search.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <button type="button" class="btn btn-primary h-fit me-3" @click="isSearching=true; getBillsTransactions()">
          <i class='bx bx-search bx-fw'></i>Search
        </button>
        <button class="btn btn-primary h-fit" @click="onExport()">
          <i class="uil uil-export me-1"></i>Export
        </button>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :fields="tableFields"
            :items="billsSellTxn"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSorting">

            <template #cell(status)="data">
              <div :class="{
                'success': data.item.status == 'success',
                'failed': data.item.status == 'failed',
                'processing': data.item.status == 'processing'
              }">
                {{ setStatus(data.item.status) }}</div>
            </template>

            <template #cell(payment_amount)="data">
              <div>₱ {{ data.item.payment_amount.toFixed(2) }}</div>
            </template>

            <template #cell(service_fee)="data">
              <div>₱ {{ data.item.service_fee.toFixed(2) }}</div>
            </template>

            <template #cell(convenience_fee)="data">
              <div>₱ {{ data.item.convenience_fee.toFixed(2) }}</div>
            </template>

            <template #cell(peddlr_conve_fee)="data">
              <div>₱ {{ data.item.peddlr_conve_fee.toFixed(2) }}</div>
            </template>

            <template #cell(final_conve_fee)="data">
              <div>₱ {{ data.item.final_conve_fee.toFixed(2) }}</div>
            </template>

            <template #cell(tot_trans_amount)="data">
              <div>₱ {{ data.item.tot_trans_amount.toFixed(2) }}</div>
            </template>

            <template #cell(merchant_comm_fee)="data">
              <div>₱ {{ data.item.merchant_comm_fee.toFixed(2) }}</div>
            </template>

            <template #cell(peddlr_share_fee)="data">
              <div>₱ {{ data.item.peddlr_share_fee.toFixed(2) }}</div>
            </template>

            <template #cell(cashback_amount)="data">
              <div>₱ {{ data.item.cashback_amount.toFixed(2) }}</div>
            </template>

            <template #cell(trans_datetime)="data">
              {{ data.item.trans_datetime | formatDate }}
            </template>

          </b-table>
        </div>
      </div>
      
      <div class="row g-0 text-center" v-if="billsSellTxnTotal == 0">
        <span>No data to display.</span>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group d-flex align-items-center">
            <label class="me-4 mb-0">Display:</label>
            <b-form-group label-for="display-record">
              <b-form-select class="form-select shadow-none w-fit"
                id="display-record"
                v-model="perPage"
                :options="pageOptions"
                @change="getBillsTransactions()"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <!-- pagination -->
        <div class="col-lg-6">
          <div class="dataTables_paginate paging_simple_numbers float-end" v-if="billsSellTxnTotal > perPage">
            <b-pagination
              class="pagination-rounded"
              v-model="currentPage"
              :total-rows="billsSellTxnTotal"
              @input="getBillsTransactions()"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import appConfig from "@/app.config";
// import { required } from "vuelidate/lib/validators";
import { customerMethods, billsPaymentMethods, billsPaymentCategoryMethodsComputed, customerListComputed, exportMethods, layoutMethods } from "@/state/helpers";
import Swal from 'sweetalert2';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "Bills Payment Transaction",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      transactions: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "id",
      sortDesc: true,
      businessId: 0,
      search: {
        field: null,
        keyword: null,
        status: null,
        dateRange: null,
      },
      searchFields: [
        { text: "Search All", value: null },
        { text: "Transaction ID", value: "trans_reference_no" },
        { text: "Biller Name", value: "sub_name" },
        { text: "Customer Name", value: "name" },
      ],
      statusOptions: [
        { text: "All", value: null },
        { text: "Success", value: "success" },
        { text: "Failed", value: "failed" },
        { text: "Processing", value: "processing" },
      ],
      rangeOptions: {
        mode: "range",
      },
      tableFields: [
        { key: "trans_reference_no", label: "Transaction ID", sortable: true, },
        { key: "sub_name", label: "Biller Name", sortable: true, },
        { key: "name", label: "Customer Name", sortable: true, },
        { key: "status", label: "Status", sortable: true, },
        { key: "cust_account_no", label: "Account Number", sortable: true, },
        { key: "payment_amount", label: "Amount", sortable: true, },
        { key: "service_fee", label: "Service Fee", sortable: true, },
        { key: "convenience_fee", label: "Supplier Convenience Fee", sortable: true, },
        { key: "peddlr_conve_fee", label: "Peddlr Convenience Fee", sortable: true, },
        { key: "final_conve_fee", label: "Final Convenience Fee", sortable: true, },
        { key: "tot_trans_amount", label: "Total Amount", sortable: true, },
        { key: "merchant_comm_fee", label: "Merchant Share", sortable: true, },
        { key: "peddlr_share_fee", label: "Peddlr Share", sortable: true, },
        { key: "cashback_amount", label: "Cashback", sortable: true, },
        { key: "trans_datetime", label: "Date", sortable: true, },
      ],
      isSearching: false,
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...customerListComputed,
    ...billsPaymentCategoryMethodsComputed,
  },
  mounted() {
    this.businessId = this.$route.params.bid;
    this.changeTitle({ title: "Bills Payment Transaction" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Merchant List", to: { name: "Subscriber" } },
        { text: "Merchant Details", to: { name: "Profile Information", params: { tab: 'Profile', bid: this.businessId} } },
        { text: "Bills Payment Transaction", to: { name: "" } },
      ],
    });
    this.getBusinessDetails({id: this.businessId});
    this.getBillsTransactions()
    this.getBillsIncome()
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...billsPaymentMethods,
    ...exportMethods,
    async getBillsTransactions() {
      this.currentPage = this.isSearching ? 1 : this.currentPage;
      this.perPage = this.isSearching ? 10 : this.perPage;

      await this.actionBillsPayment({
        action: "sell-report",
        body: {
          businessId: this.businessId,
          page: this.currentPage,
          rows: this.perPage,
          orderDesc: this.sortDesc,
          sort: this.sortBy,
          dateRange: this.search.dateRange,
          status: this.search.status,
          searchField: this.search.field,
          search: this.search.keyword
        }
      }).then(() => {
        this.transactions = this.billsSellTxn;
        this.isSearching = false; 
      })
    },
    async getBillsIncome() {
      await this.actionBillsIncome({
        action: "get-bills-income",
        body: {
          businessId: this.businessId
        }
      })
    },
    async onExport(){
      if(this.billsSellTxnTotal == 0){
        Swal.fire("Export Cannot Proceed!", "No record(s) to export.", "info");
        return;
      }

      let params = {
          module: 'bills_payment_sell_logs',
          email: JSON.parse(localStorage.getItem('userData')).email,
          businessId: this.businessId,
          orderDesc: this.sortDesc,
          sort: this.sortBy,
          dateRange: this.search.dateRange,
          status: this.search.status,
          searchField: this.search.field,
          search: this.search.keyword
        };
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    setStatus(status) {
      return status == 'success' ? 'Success' : status == 'failed' ? 'Failed' : 'Processing';
    },
    async tableSorting(action) {
      this.isSearching = true;
      this.sortBy = action.sortBy;
      this.sortDesc = action.sortDesc;
      await this.getBillsTransactions();
    }
  },
};
</script>

<style>
.mdi-wallet,
.bx-globe,
.bx-user-circle,
.bx-store-alt {
  font-size: 25px;
  color: #7f4697;
}

.label-header {
  font-size: 16px;
}

.fs-13px {
  font-size: 13px;
}

.status-form-select {
  width: 170px;
}

.success {
  color: #508F30;
}

.failed {
  color: #C12928;
}

.processing {
  color: #F7CC53;
}
</style>
